(function() {
  const normalize = s => s.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // ✏️ EDITAR AQUÍ PARA MÁS REDIRECCIONES:
  const redirects = [
    { terms: ['hot sale'],                  url: '/pages/hot-sale-new-era' },
    { terms: ['buen fin'],                  url: '/pages/buen-fin-new-era' },
    { terms: ['promociones', 'promocion', 'descuento', 'descuentos', 'oferta', 'ofertas', 'sale', 'baja', 'bajas', 'rebaja', 'rebajas'],  url: '/pages/promociones' },
  ];

  function getRedirectUrl(query) {
    const q = normalize(query);
    for (const rule of redirects) {
      if (rule.terms.map(normalize).includes(q)) return rule.url;
    }
    return null;
  }

  // Interceptar submit de formularios de búsqueda
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const url = getRedirectUrl(input.value);
    if (url) {
      e.preventDefault();
      window.location.href = url;
    }
  }, true);

  // Fallback: por si alguien llega directo a /search con la URL
  if (window.location.pathname === '/search') {
    const params = new URLSearchParams(window.location.search);
    const url = getRedirectUrl(params.get('q') || '');
    if (url) window.location.replace(url);
  }
})();
